<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="FrameId"
      ref="list"
      unit="布产框"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="api.list"
      :query-params="params"
      urlHash="production/clothmanagement/frame"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
      <template #expand-content="{ row }">
        <div>{{row}}</div>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pr/frame").default,
      params: {
        JobName: "",
        Status: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    emptyRows(ids) {
      this.api.cleanUp({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("清除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>